import styled from 'styled-components';
import media from 'src/styles/Media.styled';

export const OptionContainer = styled.div`
    display: flex;
    justify-content: space-between;
    width: 100%;
    margin: 0;
    padding: 0;
    cursor: auto;
    padding: ${({ padding }) => (padding ? padding : '5px 10px')};
    & .template {
        font-size: 14px;
        color: #140f4b;
        font-family: AvenirNextWorld Regular;
    }
`;
export const OptionCoverageContainer = styled.div`
    width: calc(100% - 0px);
`;

export const OuterContainer = styled.div`
    display: ${(props) => (props.display ? props.display : 'flex')};
    flex-direction: ${(props) => (props.isLoadMore ? 'column' : 'row')};
    margin: 0;
    padding-left: 0;
    width: 100%;
    position: relative;
    margin: ${(props) => (props.margin ? props.margin : '0')};
`;

export const LineSeparator = styled.hr`
    border: 0;
    border-top: 2px solid #e8e8e8;
    box-sizing: content-box;
    height: 0;
    ${'' /* width: 100%; */}
    overflow: visible;
    margin: 0px 8px -1px 8px;
`;


export const AccountFieldTitle = styled.label`
    color: #140f4b;
    font-size: 14px;
    //HCP id slanting
    //font-family: AvenirNextWorld Regular;
    font-family: ${(props) =>
        props.fontFamily ? props.fontFamily : 'AvenirNextWorld Regular'};
    display: inline-block;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: ${(props) => (props.width ? props.width : '100%')};
    margin: ${(props) => (props.margin ? props.margin : '0px')};
    cursor: pointer;
    ${media.mediumDevice`
         max-width: ${(props) => (props.iPadwidth ? props.iPadwidth : '25vw')};
    `}
    ${media.mobileDevice`
        max-width: ${(props) =>
            props.mobileWidth ? props.mobileWidth : 'auto'};
    `}
`;

export const AccountFieldAddress = styled.label`
    color: #140f4b;
    opacity: 0.7;
    font-size: 12px;
    font-family: AvenirNextWorld Regular;
    display: inline-block;
    /* margin-right: 10px; */
    max-width: ${(props) => (props.width ? props.width : 'auto')};
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    cursor: pointer;
    margin: ${(props) => (props.margin ? props.margin : '0px')};
    ${media.mediumDevice`
         max-width: ${(props) => (props.iPadwidth ? props.iPadwidth : '25vw')};
    `}
    ${media.mobileDevice`
        max-width: ${(props) =>
            props.mobileWidth ? props.mobileWidth : 'auto'};
    `}
`;

export const OptionAccountContainer = styled.div`
    width: calc(100% - 24px);
`;

export const DefaultContainer = styled.div`
    display:flex;
    justify-content:space-between;
`;